import React from 'react';

export const Intro = (): JSX.Element => {
	return (
		<div className="intro">
			<h1 className="intro__title">James Hoffmann&apos;s Ultimate V60 Technique</h1>

			<p className="intro__text">
				Within James&apos; recommended technique for making coffee with the Hario V60, he suggests a brew ratio of 60g of coffee per 1 litre
				of water. To save you the trouble of working out the amount of water to pour for each stage, just enter the amount of ground coffee
				you&apos;d like for your brew, and see the guide update.
			</p>
		</div>
	);
};
